/**
 *
 *
 *
 *
 */
export function preventClickBubbling(tag: HTMLElement) {
    tag.addEventListener("click", (event) => {
        event.stopPropagation();
        event.preventDefault();
    });
}

const MIN_RATIO_TO_FADE_IN = 0.8;
export function registerVisibilityObserver(element: HTMLElement, callback: () => void) {
    const options: IntersectionObserverInit = {
        threshold: MIN_RATIO_TO_FADE_IN,
    };

    const observer = new IntersectionObserver((entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
        for (const entry of entries) {
            if (entry.intersectionRatio >= MIN_RATIO_TO_FADE_IN) {
                callback();
                observer.unobserve(entry.target);
            }
        }
    }, options);
    observer.observe(element);
}